import debounce from "lodash.debounce";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import { ItemModelV2 } from "../../../inventory/models/item_model";
import { fetchGet, toQueryString } from "../../../../service/api_client";
import AutoCompleteField from "../../../../ui/new_components/common/autocomplete";
import { MasterItemStatus } from "../../../../utils/enums";

interface ItemSearchFieldPropsV2 {
  onSelect: (data: ItemModelV2) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: ItemModelV2;
}

const ProductSearchField: FunctionComponent<ItemSearchFieldPropsV2> = (
  props,
) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [addNew, setAddNew] = useState(false);
  const [data, setData] = useState<ItemModelV2[]>();
  const getData = async (prop: {
    item_name?: string;
    page: number;
    count: number;
    status: string;
    all?: boolean;
  }) => {
    prop.status = MasterItemStatus.Approved;
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        const filteredData = res.data.data.filter(
          (item: any) =>
            item?.subcategory === "Finished Goods" && item?.type === "Product",
        );
        setData(filteredData);
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query)
        getData({
          item_name: query,
          page: 1,
          count: 1,
          all: true,
          status: MasterItemStatus.Approved,
        });
      else setData(undefined);
    }, 500),
    [],
  );

  useEffect(() => {
    console.log("Search", search);

    if (search && edit) {
      if (props.value && props.value.name === search) return;
      debouncedHandler(search);
    }
  }, [search]);
  useEffect(() => {
    if (
      props.value &&
      props.value !== undefined &&
      Object.keys(props.value).length > 0
    ) {
      setSearch(`${props.value.name}`);
    }
  }, [props.value]);

  useEffect(() => {
    if (props.disabled) {
      setEdit(false);
      if (
        props.value &&
        props.value !== undefined &&
        Object.keys(props.value).length > 0
      ) {
        setSearch(`${props.value.name}`);
      }
    }
  }, [props.disabled, props.value]);

  return (
    <div className="flex gap-1 items-center    w-full">
      {edit ? (
        <AutoCompleteField
          disabled={props.disabled}
          onAddNew={() => {
            setAddNew(true);
          }}
          loading={loading}
          value={search}
          placeholder={props.placeholder ?? "Select an item "}
          onSelect={(val) => {
            setEdit(false);
            setSearch(props.value ? `${props.value.name}` : "");
            props.onSelect(val.value);
          }}
          suggestions={data?.map((d) => ({
            label: (
              <div className="text-xs">
                <b>{d.name}</b>
              </div>
            ),

            value: d,
          }))}
          onChange={setSearch}
        />
      ) : (
        <div
          title={search}
          className={`text-xs px-3 py-2 h-8 rounded focus:outline-none w-full border ${
            search ? "overflow-x-auto whitespace-nowrap" : "text-gray-400"
          }`}
          style={{ maxWidth: "100%", overflowY: "hidden", overflowX: "auto" }}
          onClick={() => {
            if (!props.disabled) {
              setEdit(true);
            }
          }}
        >
          {search || props.placeholder || "Select an item "}
        </div>

        // Larger Version
        // <div
        //   title={search}
        //   className={`text-sm px-4 py-3 h-12 rounded focus:outline-none w-full border ${
        //     search ? "overflow-x-auto whitespace-nowrap" : "text-gray-400"
        //   }`}
        //   style={{
        //     maxWidth: "100%",
        //     overflowY: "hidden",
        //     overflowX: "auto",
        //   }}
        //   onClick={() => {
        //     if (!props.disabled) {
        //       setEdit(true);
        //     }
        //   }}
        // >
        //   {search || props.placeholder || "Select an item "}
        // </div>
      )}
    </div>
  );
};

export default ProductSearchField;
